<template>
    <InfosList></InfosList>
</template>
  
<script>
  import InfosList from '@/components/Infos/InfosList.vue'
  
  export default {
    name: 'InfoView',
    components: {
      InfosList
    }
  }
</script>
  